import { apiFormData } from 'src/api/axios';

export interface PartType {
  name: string;
  part_category_id: number;
  parts?: Array<any>;
}

export const useAddPart = (params: PartType) => apiFormData.post(`/api/cms/part`, params);
